// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Associados_containerPrincipal__y8kHm"};